(ns web3.re-frame.async
  (:require [re-frame.core :as rf]
            [kitchen-async.promise :as p]
            [web3.re-frame.interceptors :as intr]))

(intr/reg-event-fx ::delayed-fx
  (fn [_ [_ fx]]
    fx))

(rf/reg-fx ::then
  ;; accepts a promise that must return fx, which are then submitted
  (fn [promise]
    (p/then promise #(rf/dispatch [::delayed-fx %]))))